






























import AssetPreview from '../AssetPreview'
import './LiveChatPreview.scss'
import Vue from 'vue'
import moment from 'moment'

export default Vue.extend(AssetPreview).extend({
  name: 'LiveChatPreview',
  props: {
    rating: {
      type: Number,
      default: 0
    },
    inScene: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    messageText (): string {
      // @ts-ignore
      if (this.asset && this.asset.data && this.asset.data.text) {
        // @ts-ignore
        return this.asset.data.text
      }
      return ''
    },
    name (): string {
      // @ts-ignore
      if (this.asset && this.asset.data && this.asset.data.user) {
        // @ts-ignore
        return this.asset.data.user
      }
      return ''
    },
    timestamp (): string {
      // @ts-ignore
      if (this.asset && this.asset.data && this.asset.data.created_at) {
        // @ts-ignore
        const date = this.asset.data.created_at
        return moment(date).fromNow() // human readable ("an hour ago")
      }
      return ''
    },
    isFavorite (): boolean {
      return this.rating > 0
    }
  },
  methods: {
    toggleFavorite () {
      const stars = (this.isFavorite) ? 0 : 5
      this.$emit('ratingChanged', stars)
    }
  }
})
